<p-toast></p-toast>

<div class="user-profile-container">
    <div class="profile-header">
        <h1 class="profile-title">Mi Perfil</h1>
        <p class="profile-subtitle">Gestiona tu información personal</p>
    </div>

    @if (loading) {
        <div class="loading-container">
            <p-progressSpinner styleClass="w-12 h-12" strokeWidth="4"></p-progressSpinner>
            <p class="loading-text">Cargando perfil...</p>
        </div>
    } @else if (usuario) {
        <div class="profile-content">
            <!-- Avatar y datos básicos -->
            <p-card class="profile-card">
                <ng-template pTemplate="header">
                    <div class="card-header">
                        <div class="avatar-section">
                            <div class="avatar-wrap">
                                <app-user-avatar size="xl" [profile]="usuario"></app-user-avatar>
                                <button
                                    type="button"
                                    class="avatar-camera"
                                    (click)="onAvatarPickRequested()"
                                    [disabled]="uploadingAvatar"
                                    [attr.aria-label]="uploadingAvatar ? 'Subiendo foto' : 'Cambiar foto de perfil'"
                                >
                                    @if (uploadingAvatar) {
                                        <p-progressSpinner styleClass="w-3 h-3" strokeWidth="4"></p-progressSpinner>
                                    } @else {
                                        <i class="pi pi-camera"></i>
                                    }
                                </button>
                                <input
                                    #avatarFileInput
                                    type="file"
                                    accept="image/*"
                                    capture="user"
                                    class="visually-hidden"
                                    (change)="onAvatarFileSelected($event)"
                                />
                            </div>
                            <div class="user-basic-info">
                                <h2 class="user-name">{{ usuario.nombre }} {{ usuario.apellido }}</h2>
                                <p-tag [value]="competenciaDisplay" severity="info" styleClass="competencia-tag"></p-tag>
                                <p class="user-email">{{ usuario.correo }}</p>
                            </div>
                        </div>
                        @if (!editMode) {
                            <app-button texto="Editar perfil" icon="edit-profile.svg" color="primary" colorTexto="white" (clickBtn)="enableEditMode()" />
                        }
                    </div>
                </ng-template>

                <div class="card-content">
                    @if (!editMode) {
                        <!-- Vista de solo lectura -->
                        <div class="info-grid">
                            <div class="info-item">
                                <label class="info-label">Nombre</label>
                                <p class="info-value">{{ usuario.nombre || 'No especificado' }}</p>
                            </div>
                            <div class="info-item">
                                <label class="info-label">Apellido</label>
                                <p class="info-value">{{ usuario.apellido || 'No especificado' }}</p>
                            </div>
                            <div class="info-item">
                                <label class="info-label">Correo electrónico</label>
                                <p class="info-value">{{ usuario.correo || 'No especificado' }}</p>
                            </div>
                            <div class="info-item">
                                <label class="info-label">Competencia</label>
                                <p class="info-value">{{ competenciaDisplay }}</p>
                            </div>
                            <div class="info-item">
                                <label class="info-label">Fecha de registro</label>
                                <p class="info-value">{{ userDateRegister || 'No especificado' }}</p>
                            </div>
                            <div class="info-item">
                                <label class="info-label">Última modificación</label>
                                <p class="info-value">{{ userDateUpdated || 'No especificado' }}</p>
                            </div>
                        </div>
                    } @else {
                        <!-- Modo edición -->
                        <form class="edit-form" (ngSubmit)="saveProfile()">
                            <div class="form-grid">
                                <div class="form-field">
                                    <label for="nombre" class="field-label">Nombre *</label>
                                    <input id="nombre" type="text" pInputText [(ngModel)]="nombre" name="nombre" class="w-full" placeholder="Ingrese su nombre" required />
                                </div>

                                <div class="form-field">
                                    <label for="apellido" class="field-label">Apellido *</label>
                                    <input id="apellido" type="text" pInputText [(ngModel)]="apellido" name="apellido" class="w-full" placeholder="Ingrese su apellido" required />
                                </div>

                                <div class="form-field">
                                    <label for="correo" class="field-label">Correo electrónico *</label>
                                    <input id="correo" type="email" pInputText [(ngModel)]="correo" name="correo" class="w-full" placeholder="correo@ejemplo.com" required />
                                </div>

                                <div class="form-field form-field--full">
                                    <label for="competencia" class="field-label">Competencia</label>
                                    <input
                                        id="competencia"
                                        type="text"
                                        pInputText
                                        [(ngModel)]="competencia"
                                        name="competencia"
                                        class="w-full"
                                        [placeholder]="defaultCompetencia"
                                        [maxlength]="competenciaMaxLength"
                                    />
                                    <small class="field-hint">Si lo dejás vacío, se mostrará "{{ defaultCompetencia }}".</small>
                                </div>
                            </div>

                            <div class="form-actions">
                                <app-button texto="Cancelar" color="gray" colorTexto="black" [desactivado]="saving" (clickBtn)="cancelEdit()" />
                                <app-button texto="Guardar cambios" color="primary" colorTexto="white" [desactivado]="!isFormValid || saving" (clickBtn)="saveProfile()" />
                            </div>
                        </form>
                    }
                </div>
            </p-card>

            <!-- Sistemas asignados -->
            @if (userSystems.length > 0) {
                <p-card class="systems-card">
                    <ng-template pTemplate="header">
                        <div class="card-header-simple">
                            <h3 class="card-title">Sistemas Asignados</h3>
                        </div>
                    </ng-template>

                    <div class="systems-grid">
                        @for (system of userSystems; track system) {
                            <p-tag [value]="system" severity="info" styleClass="system-tag"></p-tag>
                        }
                    </div>
                </p-card>
            }

            <!-- Información adicional -->
            <p-card class="additional-info-card">
                <ng-template pTemplate="header">
                    <div class="card-header-simple">
                        <h3 class="card-title">Información Adicional</h3>
                    </div>
                </ng-template>

                <div class="additional-info">
                    <div class="info-row">
                        <i class="pi pi-id-card info-icon"></i>
                        <span class="info-text"
                            >ID de usuario: <strong>{{ usuario.id }}</strong></span
                        >
                    </div>
                    <div class="info-row">
                        <i class="pi pi-users info-icon"></i>
                        <span class="info-text"
                            >Grupos asignados: <strong>{{ usuario.grupos.length || 0 }}</strong></span
                        >
                    </div>

                    <div class="info-row">
                        <div class="block">
                            <i class="pi pi-tags info-icon"></i>
                            <span class="info-text mx-4">Perfiles asignados: </span>

                            @for (item of userPerfiles; track item.sistema) {
                                <div class="my-4">
                                    <p class="sistema-perfil">
                                        {{ item.sistema }}
                                    </p>

                                    <div class="flex flex-wrap gap-2">
                                        @for (perfil of item.perfiles; track perfil) {
                                            <p-tag severity="info" styleClass="perfil-tag"> » {{ perfil }} </p-tag>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </p-card>
        </div>
    } @else {
        <div class="error-container">
            <i class="pi pi-exclamation-triangle error-icon"></i>
            <h3 class="error-title">Error al cargar el perfil</h3>
            <p class="error-message">No se pudo cargar la información del usuario.</p>
            <app-button texto="Reintentar" color="primary" colorTexto="white" (clickBtn)="loadUserProfile()" />
        </div>
    }
</div>
